import type { SortableItemUIProps } from "@tql/ui-components-react/kendo/sortable";
import { FormField } from "@tql/ui-components-react/tql/form/beta";

import type { Stop } from "~/features/ftl/shared/ftl-stop";

import { FtlStop } from "./ftl-stop/ftl-stop.tsx";
import styles from "./sortable-item-ui.module.css";

export function QuoteSortableItemContainer(
	props: Readonly<SortableItemUIProps>,
) {
	const dataItem = props.dataItem as Stop;
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- props comes from Kendo
	const attributes = props.attributes;
	const forwardRef = props.forwardRef;
	const style = props.style;
	return (
		<div
			key={dataItem.id}
			ref={forwardRef}
			className={styles.stop}
			data-testid={`stop-wrapper-${dataItem.id}`}
			id={`stop-${dataItem.id}`}
			style={{ ...style, cursor: "move" }}
			{...attributes}
		>
			<FormField component={FtlStop} stop={dataItem} />
		</div>
	);
}
